import React from "react";
import { hydrateRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import configureStore from "./store";
import App from "./App";


// Use the preloaded state from the server
const preloadedState = window.__PRELOADED_STATE__;
 delete window.__PRELOADED_STATE__; 

// console.log("Hydrating Redux with state:", preloadedState);

const store = configureStore(preloadedState);

hydrateRoot(
  document.getElementById("root"),
  <Provider store={store}>
    <BrowserRouter future={{
        v7_startTransition: true,
        v7_relativeSplatPath: true,
      }}>
      <App />
    </BrowserRouter>
  </Provider>
);

